// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './style.css';

import Logo from '../../assets/teensthings-logo.png';

// load config
import Config from '../../config/config';

export default function TopMenu() {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'menu' });
  const languages = Config.languages;

  let entityKey = 0;


  return (
    <div className="top-menu">
      <Navbar style={{ backgroundColor: "var(--bs-dark)", position: "sticky" }} collapseOnSelect expand="md" bg="dark" variant="dark">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img src={Logo} style={{ height: 30, width: 30 }} alt="Teens Things" title="Teens Things" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title={t('products_pedals')}>
                <NavDropdown.Item eventKey={entityKey++} as={Link} to="/pedals/fuzz-rffz">{t('products_pedalsRFFZ')}</NavDropdown.Item>
                <NavDropdown.Item eventKey={entityKey++} as={Link} to="/pedals/muff-mfbz">{t('products_pedalsMFBZ')}</NavDropdown.Item>
              </NavDropdown>
  {/*<NavDropdown title={t('products_lutherie')}>
                <NavDropdown.Item eventKey={entityKey++} as={Link} to="/pickupwindingmachine/manual">{t('products_pickupwindingmachineManual')}</NavDropdown.Item>
                <NavDropdown.Item eventKey={entityKey++} as={Link} to="/pickupwindingmachine/cnc">{t('products_pickupwindingmachineCNC')}</NavDropdown.Item>
  </NavDropdown>*/}
              <Nav.Link eventKey={entityKey++} as={Link} to="/about">{t('about')}</Nav.Link>
              <Nav.Link eventKey={entityKey++} as={Link} to="/contacts">{t('contacts')}</Nav.Link>
            </Nav>
            {languages.length > 1 ? (
              <Nav>
                <NavDropdown title={t('selectlanguage')} id="basic-nav-dropdown">
                  {languages.map(item => (
                    <NavDropdown.Item eventKey={entityKey++} key={item} onClick={() => i18n.changeLanguage(item)}>{item.toLowerCase()}</NavDropdown.Item>
                  ))}
                </NavDropdown>
              </Nav>
            ) : null}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
